import { Button, Form, Modal, Space } from 'antd';
import React, { useState } from 'react';

import { EdutainmentDetailModal } from '@/components/UI/EdutainmentDetailModal';

import {
  InformationSection,
  PricingSection,
  ScheduleSection,
} from './components';
import { TEST_EDUTAINMENT_DETAIL } from './constants';
import styles from './index.module.scss';
import type { EditEdutainmentFormValues, EdutainmentDetail } from './types';

const { useForm } = Form;

const modalBodyStyles: React.CSSProperties = {
  maxHeight: '95vh',
  overflowY: 'auto',
};

type EditEdutainmentModalProps = {
  open: boolean;
  closeEditModal: () => void;
  refundPolicy: string;
};

export const EditEdutainmentModal = ({
  open,
  closeEditModal,
  refundPolicy,
}: EditEdutainmentModalProps) => {
  const [form] = useForm<EditEdutainmentFormValues>();

  const [showDetailModal, setShowDetailModal] = useState(false);
  const [edutainmentDetail, setEdutainmentDetail] = useState<
    EdutainmentDetail | undefined
  >(undefined);

  const closeModal = () => {
    form.resetFields();
    closeEditModal();
  };

  const onPreviewButtonClick = async () => {
    try {
      const formValues = await form.validateFields();
      setEdutainmentDetail({ ...formValues, refundPolicy });
      setShowDetailModal(true);
    } catch {
      return;
    }
  };

  const onSubmit = async () => {
    const formValues = await form.validateFields();

    console.log('Submitted formValues:', formValues);

    // TODO: 這邊之後要補上打建立育樂活動申請API的邏輯

    setEdutainmentDetail(undefined);
    setShowDetailModal(false);
    closeEditModal();
  };

  return (
    <>
      <Modal
        open={open}
        centered
        destroyOnClose
        maskClosable={false}
        width={1242}
        onCancel={closeModal}
        footer={null}
        bodyStyle={modalBodyStyles}
      >
        <Form
          layout="vertical"
          form={form}
          // initialValues={INIT_FORM_VALUES}
          initialValues={TEST_EDUTAINMENT_DETAIL} // TODO: 僅測試用，最後記得刪除，然後改用回上面的INIT_FORM_VALUES
        >
          <Space
            direction="vertical"
            size="middle"
            className={styles.modalBody}
          >
            <InformationSection />
            <PricingSection />
            <ScheduleSection />

            <Space className={styles.actionButtons}>
              <Button onClick={closeModal}>取消</Button>
              <Button type="primary" onClick={onPreviewButtonClick}>
                預覽
              </Button>
            </Space>
          </Space>
        </Form>
      </Modal>

      {edutainmentDetail ? (
        <EdutainmentDetailModal<EdutainmentDetail>
          open={showDetailModal}
          onCancel={() => setShowDetailModal(false)}
          edutainment={edutainmentDetail}
          modalFooter={[
            <Button
              key="edit"
              type="primary"
              onClick={() => setShowDetailModal(false)}
            >
              修改
            </Button>,
            <Button key="ok" htmlType="submit" onClick={onSubmit}>
              確認
            </Button>,
          ]}
        />
      ) : null}
    </>
  );
};
